// Small display helpers shared by the landing sections.

export const pad = (value: number): string => String(value).padStart(2, '0')

// "https://www.strehajone.com/" becomes "strehajone.com", "https://fb.com/prishtinatalks" keeps its path.
export const displayUrl = (url: string): string => {
    try {
        const parsed = new URL(url)
        const host = parsed.hostname.replace(/^www\./, '')
        const path = parsed.pathname.replace(/\/$/, '')

        return `${host}${path}`
    }
    catch {
        return url
    }
}

// Picks a readable text colour for a hex background.
export const readableOn = (hex: string): string => {
    const value = hex.replace('#', '')
    const full = value.length === 3 ? value.split('').map((char) => char + char).join('') : value

    if (!/^[0-9a-f]{6}$/i.test(full)) return '#141415'

    const channel = (offset: number) => {
        const raw = parseInt(full.slice(offset, offset + 2), 16) / 255

        return raw <= 0.03928 ? raw / 12.92 : ((raw + 0.055) / 1.055) ** 2.4
    }

    const luminance = 0.2126 * channel(0) + 0.7152 * channel(2) + 0.0722 * channel(4)

    return luminance > 0.18 ? '#141415' : '#f4f8fb'
}

export const clamp01 = (value: number): number => Math.min(1, Math.max(0, value))
